module.exports = __webpack_public_path__ + "img/icon-painspot.babe2f82.svg";